export const DEFAULT_AUTHENTICATED_ROUTE = '/home';
export const DEFAULT_UNAUTHENTICATED_ROUTE = '/login';
